import AvdragsfrihetForm from './avdragsfrihet-form';

export default AvdragsfrihetForm;
